document.addEventListener('DOMContentLoaded', function () {
  var details = document.querySelectorAll('.header__inline-menu details');
  
  details.forEach(function (el) {
    var timeout;

    el.addEventListener('mouseenter', function () {
      clearTimeout(timeout);
      el.setAttribute('open', '');
    });

    el.addEventListener('mouseleave', function () {
      timeout = setTimeout(function () {
        el.removeAttribute('open');
      }, 200);
    });

    var summary = el.querySelector('summary');
    if (summary) {
      summary.style.cursor = 'pointer';
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/products/cari';
      });
    }
  });
});
